import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";

function CreditPurchaseService(token, creditPackage, name, email) {
    return (
        axios.post(`${CURRENT_API_URL}/payment/buy-credits`, {
            email: email,
            name: name,
            creditPackage: creditPackage,

        }, {
            headers: {
                'Authorization': token,
            }
        }).then(res => {
            return res.data;
        })
    );
}

export default CreditPurchaseService;